import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class WorkersRequest extends GenericRequest {

    term;
    page;
    filter;
    company_id;
    show_only_deleted;
    include_only_contractor_workers;
    include_only_company_workers;
    retrieve_worker_documentation_state;

    constructor(
        page,
        term = '',
        filter = 0,
        company_id = null,
        show_only_deleted = false,
        include_only_contractor_workers = false,
        include_only_company_workers = false,
        retrieve_worker_documentation_state = true,
    ) {
        super(METHOD_POST, ApiEndpoints.WORKERS);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.company_id = company_id;
        this.show_only_deleted = show_only_deleted;
        this.include_only_contractor_workers = include_only_contractor_workers;
        this.include_only_company_workers = include_only_company_workers;
        this.retrieve_worker_documentation_state = retrieve_worker_documentation_state;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.worker_state_ids = [this.filter];
        if ( this.company_id ) request.criteria.company_id = this.company_id;
        if ( this.include_only_contractor_workers ) request.criteria.include_only_contractor_workers = this.include_only_contractor_workers;
        if ( this.include_only_company_workers ) request.criteria.include_only_company_workers = this.include_only_company_workers;
        if ( this.retrieve_worker_documentation_state ) request.criteria.retrieve_worker_documentation_state = this.retrieve_worker_documentation_state;
        request.criteria.show_only_deleted = this.show_only_deleted;
        request.criteria.skip_companies_inactive = true;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/worker/ws/WorkersRequest.js